export enum GpsPermissionType {
  None= "None",
  Foreground = "Foreground",
  All = "All"
}
